module.exports = __webpack_public_path__ + "static/img/knives11.34f47ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives11.jpg
// module id = /Y5Y
// module chunks = 0